exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 1400px){\n.prediction-number{\n        min-width: 20px !important;\n        width: 40px !important;\n}\n}\n   \n", ""]);

// exports
